import { render, staticRenderFns } from "./DocumentTemplateForm.vue?vue&type=template&id=720749b3&"
import script from "./DocumentTemplateForm.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports